import React, { useEffect, useState, useRef, useCallback } from 'react';
// import { Select, Menu, TextInput, Text } from '@mantine/core';
import helpers from '@starflow/app/helpers';
import { EditableText } from '@shakkerai/pro-components';

// import styles from './tool.module.scss';
import { SizeInputGroup, FrameSize } from './components';
import { ColorPicker, ImageTool } from '@shakkerai/pro-atoms';
// import { Ellipse } from 'react-konva';

const labelStyle = { label: { fontSize: '12px' } };

const Divider = () => <div className="h-[16px] bg-[#D9D9D9] w-[1px] mx-[8px]"></div>;

export const ShapeTool = React.memo((props) => {
  const { element, showColorPicker = true } = props;
  const [value, setValue] = useState({});

  const [disabled, setDisabled] = useState(false);

  const updateCanvas = (id, data, params) => {
    helpers.canvas.updateElementData(id, data);
    helpers.canvas.updateElement(id, {
      ...params,
      rotation: parseInt(data?.rotation || 0, 10),
    });
    helpers.canvas.updateSelectionFrame();
    setValue(data);
  };

  const handleChange = (updatedData) => {
    // element data数据，不要修改了
    const elementData = {
      ...element.data,
      ...value,
      ...updatedData,
    };

    // canvas相关的值
    const params = {};

    if (element.type === 'shape_square') {
      Object.assign(params, {
        width: elementData.width / element.scaleX,
        height: elementData.height / element.scaleY,
        // scaleX: elementData.width / element.width,
        // scaleY: elementData.height / element.height,
      });
      // 锁定比例时，把缩放重置为1
      if (updatedData.isFixedRatio) {
        params.scaleX = 1;
        params.scaleY = 1;
      }
    }

    if (element.type === 'shape_circle') {
      const minSize = Math.min(elementData.width, elementData.height);
      Object.assign(params, {
        scaleX: elementData.width / minSize,
        scaleY: elementData.height / minSize,
        width: minSize,
        height: minSize,
      });
    }

    updateCanvas(element.id, elementData, params);
  };

  // 这里回填tool里的数据，不要做其他操作了
  useEffect(() => {
    const { scaleX, scaleY, rotation, width: w, height: h } = element;
    const width = parseInt(Math.ceil(w * scaleX * 100000000) / 100000000);
    const height = parseInt(Math.ceil(h * scaleY * 100000000) / 100000000);
    const params = {
      ...value,
      rotation,
      width,
      height,
    };
    setValue(params);
  }, [element.scaleX, element.scaleY, element.rotation]);

  return (
    <div className="flex items-center pointer-events-auto bg-white">
      <div className="flex items-center justify-between w-[293px]">
        <FrameSize
          disabled={disabled}
          value={value}
          shape={element.data.shape}
          element={element}
          onChange={handleChange}
        />
        <SizeInputGroup disabled={disabled} value={value} element={element} onChange={handleChange} />
      </div>
      <Divider />
      <div className="h-6 flex items-center bg-[#F4F6F8] px-[8px]">
        <div className="text-[#909090] translate-y-px text-[11px] shrink-0">R</div>
        <EditableText
          className="text-center w-[45px]"
          styles={labelStyle}
          name="width"
          value={Math.round(element.rotation)}
          onChange={(rotation) => {
            if (!isNaN(rotation)) {
              handleChange({ ...value, rotation });
            }
          }}
        />
      </div>

      {showColorPicker && (
        <>
          <Divider />
          <div className="">
            <ColorPicker
              value={element.data.backgroundColor}
              onChange={(color) => handleChange({ ...value, backgroundColor: color })}
            />
          </div>
        </>
      )}
      <Divider />
      <ImageTool element={element} />
    </div>
  );
});
